import moment from 'moment';
import Firebase from '../../../lib/Firebase';
import Firestore from '../../../lib/Firestore';

export default {
  all(city) {
    return Firebase.firestore()
      .collection('cities')
      .doc(city.docId)
      .collection('delivery-options')
      .get()
      .then(docs => {
        return Firestore.getCollectionData(docs);
      });
  },

  manage(
    city,
    docId,
    label,
    startTime,
    endTime,
    closeTime,
    isExpress,
    isToday,
    active,
    expressDeliveryCharge
  ) {
    const deliveryOptionObj = {
      label: label,
      startTime: moment(startTime).format('HH:mm A'),
      endTime: moment(endTime).format('HH:mm A'),
      closeTime: moment(closeTime).format('HH:mm A'),
      active: active,
      isToday: isToday,
      isExpress: isExpress,
      expressDeliveryCharge: expressDeliveryCharge || 0
    };

    const promise = docId
      ? Firebase.firestore()
          .collection('cities')
          .doc(city.docId)
          .collection('delivery-options')
          .doc(docId)
          .update(deliveryOptionObj)
      : Firebase.firestore()
          .collection('cities')
          .doc(city.docId)
          .collection('delivery-options')
          .add(deliveryOptionObj);

    return promise;
  },

  deleteOption(city, option) {
    return Firebase.firestore()
      .collection('cities')
      .doc(city.docId)
      .collection('delivery-options')
      .doc(option.docId)
      .delete();
  }
};



// WEBPACK FOOTER //
// ./src/pages/cities/DeliveryOptions/service.js